import AtriumPanel from "@/components/atrium/AtriumPanel";

export default function AtriumPipeline() {
  return (
    <div className="p-5 flex flex-col gap-4">
      <div>
        <div className="text-[24px] font-semibold tracking-[-0.02em]">Pipeline</div>
        <div className="text-[13px] mt-0.5" style={{ color: "var(--a-muted)" }}>
          Not connected to a trusted CRM source yet.
        </div>
      </div>

      <AtriumPanel title="Disabled">
        <div className="px-[14px] py-6 max-w-[620px] text-[13px] leading-relaxed" style={{ color: "var(--a-muted)" }}>
          Pipeline, MRR, capacity, and referral metrics are hidden until they are backed by real
          bizdev tracker or CRM data. This cockpit will not show sample deals or estimated
          business figures.
        </div>
      </AtriumPanel>
    </div>
  );
}
